import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "author-menu"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "author-name"
};
const _hoisted_4 = {
  key: 2,
  class: /*@__PURE__*/_normalizeClass(['author-name-wrapper'])
};
const _hoisted_5 = {
  key: 0,
  class: "author-name"
};
import { useAuthorStore } from '@/stores';
import { computed, toRefs } from 'vue';
import { MgDropPanel } from '@/share/components/xeui';
import { formatSize } from '@/utils';
import imgAvatar01 from '@/assets/images/avatar_01.png';

import { storeToRefs } from 'pinia';
export default {
  __name: 'mg-author-menu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    avatarSize: {
      type: [Number, String],
      default: 32
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: true
    },
    showMenu: {
      type: Boolean,
      default: true
    }
  },
  emits: ['menu-click', 'avatar-click'],
  setup(__props, {
    emit: __emit
  }) {
    const authorStore = useAuthorStore();
    const {
      user,
      token,
      org
    } = storeToRefs(authorStore);
    const {
      avatar
    } = toRefs(user.value);
    const props = __props;

    // const userAvatar = computed(() => {
    //     return !avatar.value ? imgAvatar01 : avatar.value;
    // });

    const displayAuthorName = computed(() => {
      const {
        nickname = ''
      } = user.value || {};
      const {
        name: orgName = ''
      } = org.value || {};
      return orgName !== '' ? `${orgName}-${nickname}` : nickname;
    });
    const avatarStyle = computed(() => {
      return {
        width: formatSize(props.avatarSize),
        height: formatSize(props.avatarSize),
        borderRadius: formatSize(props.avatarSize / 2)
      };
    });
    const emit = __emit;
    const loadAvatarFail = () => {
      if (avatar.value !== imgAvatar01) {
        avatar.value = imgAvatar01;
      }
    };
    const handleMenuClick = ({
      item,
      $event
    }) => {
      emit('menu-click', {
        item,
        $event,
        user,
        token
      });
    };
    const handleAvatarClick = e => {
      emit('avatar-click', {
        $event: e,
        user
      });
    };
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.showAvatar ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "author-avatar-wrapper",
        style: _normalizeStyle(avatarStyle.value),
        onClick: handleAvatarClick
      }, [_createElementVNode("img", {
        alt: "",
        src: _unref(avatar),
        onError: loadAvatarFail
      }, null, 40, _hoisted_2)], 4)) : _createCommentVNode("", true), __props.items && __props.items.length > 0 ? (_openBlock(), _createBlock(_unref(MgDropPanel), {
        key: 1,
        trigger: "hover",
        placement: "bottom-right"
      }, {
        default: _withCtx(({
          isOpen
        }) => [_createElementVNode("div", {
          class: _normalizeClass(['author-name-wrapper', {
            'is--hover': isOpen
          }])
        }, [__props.showName ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(displayAuthorName.value), 1)) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("i", {
          class: "vxe-icon-menu"
        }, null, -1))], 2)]),
        "pop-panel": _withCtx(({
          isOpen
        }) => [_renderSlot(_ctx.$slots, "prefix-panel", {
          isOpen: isOpen
        }), _renderSlot(_ctx.$slots, "pop-panel", {
          isOpen: isOpen
        }, () => [_createVNode(_component_vxe_button_group, {
          vertical: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, idx) => {
            return _openBlock(), _createBlock(_component_vxe_button, {
              key: `item_${idx}`,
              mode: "text",
              size: "large",
              style: {
                "width": "100%"
              },
              onClick: e => handleMenuClick({
                item,
                $event: e
              })
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))]),
          _: 1
        })]), _renderSlot(_ctx.$slots, "suffix-panel", {
          isOpen: isOpen
        })]),
        _: 3
      })) : _createCommentVNode("", true), !__props.items || !__props.items.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [__props.showName ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(displayAuthorName.value), 1)) : _createCommentVNode("", true), _cache[1] || (_cache[1] = _createElementVNode("i", {
        class: "vxe-icon-menu"
      }, null, -1))])) : _createCommentVNode("", true)]);
    };
  }
};